import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import colors from '../../../shared-colors';
import { useTranslation } from 'react-i18next';

const LoadingState = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
      }}
    >
      <CircularProgress
        size={40}
        sx={{
          color: colors.mainBlue,
          mb: 2,
        }}
      />
      <Typography
        variant="body1"
        sx={{
          color: colors.grayText,
          fontWeight: 500,
        }}
      >
        {t('loadingDoctorVisits')}
      </Typography>
    </Box>
  );
};

export default LoadingState;
